import { getStringFromDate } from '@sit/core';
import { useQueryClient, } from '@tanstack/react-query';
import { parseISO } from 'date-fns/parseISO';
import { useGetApiTimesheets, } from '../../generated/sitComponents';
import { timesheetsPredicate, timesheetsQueryKey } from './query';
const transformGetTimesheetResponseItem = ({ startDate: startDate_value, endDate: endDate_value, ...timesheet }, currentlySubmittingTimesheetIds) => {
    return {
        startDate: parseISO(startDate_value),
        endDate: parseISO(endDate_value),
        ...timesheet,
        submitState: timesheet.submitState ??
            (currentlySubmittingTimesheetIds.has(timesheet.id)
                ? 'SUBMITTING'
                : undefined),
    };
};
const transformGetApiTimesheetsResponseItem = ({ startDate: startDate_value, endDate: endDate_value, ...timesheet }) => {
    return {
        startDate: getStringFromDate(startDate_value),
        endDate: getStringFromDate(endDate_value),
        ...timesheet,
    };
};
export const transformGetApiTimesheetsResponse = (response) => {
    return response.map((timesheet) => transformGetApiTimesheetsResponseItem(timesheet));
};
export const parseGetApiTimesheetsResponse = (response, currentlySubmittingTimesheetIds) => {
    return response.map((timesheet) => transformGetTimesheetResponseItem(timesheet, currentlySubmittingTimesheetIds));
};
function useCurrentlySubmittingTimesheetIds() {
    const queryClient = useQueryClient();
    const timesheetsQueryData = queryClient.getQueriesData({
        queryKey: timesheetsQueryKey,
        predicate: timesheetsPredicate,
    });
    const set = new Set();
    for (const [_, timesheets] of timesheetsQueryData) {
        for (const timesheet of timesheets ?? []) {
            if (timesheet.submitState === 'SUBMITTING') {
                set.add(timesheet.id);
            }
        }
    }
    return set;
}
export function useGetTimesheets(variables, options) {
    const currentlySubmittingTimesheetIds = useCurrentlySubmittingTimesheetIds();
    const result = useGetApiTimesheets(variables, options);
    return {
        ...result,
        data: result.data
            ? parseGetApiTimesheetsResponse(result.data, currentlySubmittingTimesheetIds)
            : undefined,
    };
}
//# sourceMappingURL=use-get-timesheets.js.map